// extracted by mini-css-extract-plugin
export var dividerLine = "_4w-0";
export var errorBackground = "_4w-1";